import React from 'react';
import { Layout } from '../components/layout';
import { useAuth } from '../store/authStore';
import { Button } from '../components/ui';
import { Icon } from '@/design-system/assets/icons/Icon.jsx';
import { useNavigate } from 'react-router-dom';

interface AccessDeniedProps {
  requiredPermission?: string;
  pageName?: string;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({ 
  requiredPermission = '관리자 권한', 
  pageName = '이 페이지' 
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            {/* 아이콘 */}
            <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-destructive/10">
              <Icon name="Shield" size={48} className="text-destructive" />
            </div>

            {/* 제목 */}
            <h2 className="mt-6 text-3xl font-bold text-foreground">
              접근 권한이 없습니다
            </h2>

            {/* 설명 */}
            <p className="mt-4 text-lg text-muted-foreground">
              {pageName}에 접근할 수 있는 권한이 없습니다.
            </p>

            {/* 현재 사용자 정보 */}
            <div className="mt-6 p-4 bg-muted rounded-lg">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Icon name="AlertTriangle" size={20} className="text-accent-foreground" />
                <span className="text-sm font-medium text-foreground">
                  현재 로그인 정보
                </span>
              </div>
              <p className="text-sm text-muted-foreground">
                사용자: <span className="font-medium">{user?.username || '알 수 없음'}</span>
              </p>
              <p className="text-sm text-muted-foreground">
                필요 권한: <span className="font-medium text-destructive">{requiredPermission}</span>
              </p>
            </div>

            {/* 안내 메시지 */}
            <div className="mt-6 p-4 bg-primary/10 border border-primary/20 rounded-lg">
              <p className="text-sm text-primary">
                이 페이지에 접근하려면 관리자 권한이 필요합니다. 
                시스템 관리자에게 문의하시기 바랍니다.
              </p>
            </div>
            
            {/* 버튼들 */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                onClick={handleGoBack}
                variant="secondary"
                className="flex items-center gap-2"
              >
                <Icon name="ArrowLeft" size={16} />
                이전 페이지로
              </Button>
              <Button
                onClick={handleGoHome}
                className="flex items-center gap-2"
              >
                <Icon name="Home" size={16} />
                대시보드로
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
